<template lang="pug">
	div

		Alerts(ref="Alerts")

		b-form(@submit.prevent='onSubmit')

			// exrta data fields
			b-form-group(v-for="cat in _event.extra_data_category" :label='cat.title' :key="cat.id")
				b-form-checkbox-group(v-model='form.extra_data' :options="options(cat)" :state="checkState(cat)")
					b-form-invalid-feedback(:state="checkState(cat)") Выберите хотя бы один пункт

			// ordinary fields
			b-form-group(v-for="field in _htmlFormModel" :key="field.name")
				b-form-checkbox(v-model="form[field.name]" :name="field.name" v-if="field.type==='checkbox'" ) {{ field.placeholder }}
				b-form-input(v-model='form[field.name]' :name="field.name" :placeholder='field.placeholder' v-else)

			div
				b-button.w-100(variant="success" type="submit" :disabled="isSending")
					b-spinner(small label="Small Spinner" v-if="isSending")
					span(v-else) {{ _submitText }}

</template>

<script>
	import { mapActions, mapState } from 'vuex';

	import Alerts from './Alerts'

	import clearFormMixin from '../../MIXINS/clearForm'

	import modelPpnt from '../../store/models/modelPpnt'
	import selectIterfacer from '../../utility/Interfacers/select'

	import FormPpntProps from './FormPpntProps';


	export default {
		name: 'FormPpnt',
		props: FormPpntProps,
		components: {
			Alerts,
		},
		mixins: [ clearFormMixin ],
		data: () => ({
			form: { ...modelPpnt },
			isSending: false
		}),
		computed: {
			...mapState(['myParticipants']),

			error(){ return this.myParticipants.post.error }
		},
		methods: {
			...mapActions(['postMyParticipant']),

			checkState(cat){ return cat.required_at_least_one_element ? this.isSomeExist(cat) : true },
			isSomeExist(cat){ return this.form.extra_data.some(id=>this.getExtraDataByCat(cat).find( item=>(item.id === id) ) ) },
			getExtraDataByCat(cat){ return this._event.extra_data.filter(item=>item.category.id===cat.id) || [] },

			options(cat){
				return this.getExtraDataByCat(cat).reduce((acc,{title,description, id})=>[...acc,{text:`${title} ${description?'('+description+')':''}`,value:id}],[])
				// return selectIterfacer( this.getExtraDataByCat(cat), ['title','id'], [])
			},
			isExtraDataHasErr() { return this._event.extra_data_category.some( item => !this.checkState(item) ) },

			collectFormData(){
				return {
					...this.form,
					parent: this._ppntID || null,
					user: this._userID || null,
					dependent_member: this._memberID || null,
					event: this._event.id
				};
			},
			onSubmit(){

				if ( this.isExtraDataHasErr() ) {
					this.$refs.Alerts.showAlert('Заполните правильно все поля', 'error');
					return false;
				}

				this.isSending = true;

				this.$store.dispatch('postMyParticipant', this.collectFormData())
					.then(this.cbOK).then(this._cbOK)
					.catch(this.cbERR).catch(this._cbERR);
			},

			cbOK(resp){
				this.$refs.Alerts.showAlert(this._msgOK, 'success');
				this.isSending = false;
				this.clearForm('form');
				return resp;
			},
			cbERR(resp){
				this.isSending = false;
				this.error.non_field_errors
					? this.$refs.Alerts.showAlert(this.error.non_field_errors[0], 'error')
					: this.$refs.Alerts.showAlert(this.error.detail, 'error');
				throw resp;
			},
		},
	}
</script>
